import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '../../store';

const selectFeatureFlagsState = (state: RootState) => state.featureFlags;

export const selectFeatureFlags = createSelector(
  selectFeatureFlagsState,
  (state) => state.flags.value ?? {}
);

export const selectFeatureFlagsLoading = createSelector(
  selectFeatureFlagsState,
  (state) => state.flags.loading
);

export const selectFeatureFlagsLoaded = createSelector(
  selectFeatureFlagsState,
  (state) => state.flags.loaded
);

export const selectIsFeatureFlagEnabled = (flagName: string) =>
  createSelector(selectFeatureFlags, (flags) => flags[flagName]?.enabled ?? false);
